module.exports = __webpack_public_path__ + "img/chinesecompany81.c9620a7b.png";